export const selectSubCategories = (state) => state.mainReducer.subCategories;
